
export default {
  props: ["method", "id"],
  data: function() {
    return { visible: false };
  },
};
